module.exports = __webpack_public_path__ + "img/thermometer-img1-1.b6736026.png";